export default __webpack_public_path__ + "static/big-tuna-fishing-6f0063969fd6e3e8f9106e778eb936dd.jpg";